@if (promotionDateRange && isPromoActive) {
    <span class="ttu c-dark-grey title-s pt-4" [ngClass]="{ 'px-4': isPageProduct }" [ngStyle]="{ color: fontColor }">
        {{ 'dev.product.detail.promotionDates' | translate: { $0: promotionDateRange.startDate, $1: promotionDateRange.endDate } }}
    </span>
}
